// extracted by mini-css-extract-plugin
module.exports = {"container":"_2TRJx","label":"_3_L7s","radioGroup":"_3p1vm"};